<template>
    <div v-if="itr || reserve || scheduledTerminationDate || citizenship || gph || firstPayroll || stage" class="payroll-employee-badges">
        <span v-if="itr" class="payroll-employee-badge payroll-itr-badge" title="Инженерно-технический работник">ИТР</span>
        <span v-if="reserve" class="payroll-employee-badge payroll-employee-badge--reserve" title="Сотрудник сейчас в резерве">Резерв</span>
        <span v-if="terminationDate" class="payroll-employee-badge payroll-employee-badge--terminated" :title="`Дата увольнения: ${terminationDate}`" :aria-label="`Уволен ${terminationDate}`">Уволен · {{ terminationDate }}</span>
        <span v-if="scheduledTerminationDate" class="payroll-employee-badge payroll-employee-badge--termination-planned" :title="`Увольнение запланировано. Последний рабочий день: ${scheduledTerminationDate}`">Увольнение запланировано · {{ scheduledTerminationDate }}</span>
        <span v-if="citizenship" class="payroll-employee-badge payroll-employee-badge--citizenship" :title="`Гражданство: ${citizenship}`" :aria-label="`Гражданство: ${citizenship}`">{{ citizenship }}</span>
        <span v-if="gph" class="payroll-employee-badge" title="Форма найма: ГПХ" aria-label="Форма найма: ГПХ">ГПХ</span>
        <span v-if="firstPayroll" class="payroll-employee-badge payroll-employee-badge--new" :title="newTitle" :aria-label="newTitle">Новый</span>
        <span v-if="stage" class="payroll-employee-badge" :class="stage > 3 ? 'payroll-employee-badge--review' : 'payroll-employee-badge--adaptation'" :title="stageTitle" :aria-label="stageTitle">{{ stage > 3 ? 'Пересмотр условий' : 'Адаптация' }} · {{ stage }}-й месяц</span>
    </div>
</template>

<script>
import {employeeTraits} from './payrollEmployeeTraits';
export default {
    name: 'PayrollEmployeeBadges',
    props: {
        employee: {type: Object, default: null},
        itr: {type: Boolean, default: false},
        attention: {type: Object, default: null}
    },
    computed: {
        traits() { return employeeTraits(this.employee, this.attention); },
        reserve() { return this.traits.reserve; },
        terminationDate() {
            const date = this.traits.terminationDate;
            return date ? date.split('-').reverse().join('.') : null;
        },
        scheduledTerminationDate() {
            const date = this.traits.scheduledTerminationDate;
            return date ? date.split('-').reverse().join('.') : null;
        },
        citizenship() { return String(this.employee && this.employee.citizenship || '').trim(); },
        gph() { return this.employee && this.employee.hiring_form === 'gph'; },
        firstPayroll() { return this.traits.firstPayroll; },
        stage() { return this.traits.stage; },
        newTitle() { return `Первое начисление зарплаты по доступной истории Аргуса.${this.stage === 1 ? ' Первый месяц адаптации.' : ''}`; },
        stageTitle() { return `${this.stage}-й месяц по доступной истории работы в Аргусе. Месяц засчитывается при работе не менее 30% календарных дней.${this.stage >= 4 ? ' Оцените результаты сотрудника и необходимость улучшить условия.' : ' Сотруднику нужно дополнительное внимание.'}`; }
    }
};
</script>

<style scoped>
.payroll-employee-badges { display: inline-flex; flex-wrap: wrap; align-items: center; gap: 4px; min-width: 0; max-width: 100%; }
.payroll-employee-badge { display: inline-block; max-width: 100%; padding: 2px 6px; border: 1px solid #b9c2cd; border-radius: 4px; background: #e7ebf0; color: #344256; font-size: 12px; font-weight: 700; line-height: 1.3; white-space: normal; overflow-wrap: anywhere; }
.payroll-employee-badge--citizenship { background: #dcecfb; border-color: #adcbe5; color: #235b87; }
.payroll-employee-badge--reserve { background: #596673; border-color: #596673; color: #fff; }
.payroll-employee-badge--terminated { background: #b52e3f; border-color: #992335; color: #fff; }
.payroll-employee-badge--termination-planned { background: #fff0e8; border-color: #c77b50; color: #8d3c1b; }
.payroll-employee-badge--new { background: #dcecfb; border-color: #82b4dc; color: #19547f; }
.payroll-employee-badge--adaptation { background: #fff2ce; border-color: #d9b35c; color: #74510f; }
.payroll-employee-badge--review { background: #eee4fa; border-color: #b69ad4; color: #654088; }
.payroll-itr-badge { background: #1976bd; border-color: #1976bd; color: #fff; }
@media (max-width: 900px) {
    .payroll-employee-badges { flex-basis: 100%; }
    .payroll-employee-badge { font-size: 13px; }
}
</style>
